export const eventAltIcon = `
<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 8.6L17.8314 7.2814C19.1544 6.32887 21 7.27427 21 8.90447V13.0955C21 14.7257 19.1544 15.6711 17.8314 14.7186L16 13.4M6 20H12C14.2091 20 16 18.2091 16 16V6C16 3.79086 14.2091 2 12 2H6C3.79086 2 2 3.79086 2 6V16C2 18.2091 3.79086 20 6 20Z" stroke="#00ABC7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`
